import { pickContactIdentity } from './contactIdentity.js';
import { normalizePhoneForMatch } from './phone.js';

const isObject = (value) => Boolean(value) && typeof value === 'object';

const looksLikeContact = (value) => {
  if (!isObject(value)) return false;
  return [
    'id',
    'name',
    'contact_name',
    'contact_phone',
    'phone_number',
    'whatsapp_number',
    'whatsapp_jid',
    'whatsapp_lid',
  ].some((key) => value[key] !== undefined && value[key] !== null && value[key] !== '');
};

export const getConversationContact = (value) => {
  if (!isObject(value)) return null;

  const contactList = Array.isArray(value.contacts) ? value.contacts.filter(looksLikeContact) : [];
  if (contactList.length > 0) return contactList[0];

  const nestedCandidates = [
    value.contact,
    value.client_contact,
    value.customer_contact,
    value.Contact_cliente,
  ];
  for (const candidate of nestedCandidates) {
    if (looksLikeContact(candidate)) return candidate;
  }

  return looksLikeContact(value) ? value : null;
};

export const getConversationContactId = (value) => {
  const contact = getConversationContact(value);
  const candidates = [
    value?.contact_id,
    value?.contactId,
    contact?.id,
    contact?.contact_id,
    value?.client_contact_id,
    value?.customer_contact_id,
    contact?.client_contact_id,
    contact?.customer_contact_id,
  ];
  for (const candidate of candidates) {
    if (candidate !== null && candidate !== undefined && candidate !== '') {
      return candidate;
    }
  }
  return null;
};

export const getConversationContactDigits = (value) => {
  const contact = getConversationContact(value);
  const candidates = [
    value?.phone_digits,
    value?.contact_phone,
    value?.phone_number,
    value?.rawWhatsappNumber,
    value?.whatsappNumber,
    value?.whatsapp_number,
    value?.whatsapp_jid,
    value?.whatsapp_lid,
    value?.jid,
    value?.remoteJid,
    value?.remote_jid,
    value?.client_phone,
    value?.customer_phone,
    contact?.phone_digits,
    contact?.contact_phone,
    contact?.phone_number,
    contact?.whatsapp_number,
    contact?.whatsapp_jid,
    contact?.whatsapp_lid,
  ];
  for (const candidate of candidates) {
    const normalized = normalizePhoneForMatch(candidate || '');
    if (normalized) return normalized;
  }
  return '';
};

export const getConversationContactIdentity = (value) => {
  const contact = getConversationContact(value);
  const directCandidates = [
    contact,
    value,
  ];
  for (const candidate of directCandidates) {
    if (!isObject(candidate)) continue;
    const identity = pickContactIdentity(candidate);
    if (identity) return identity;
  }
  return '';
};

export const getConversationCompanyName = (value) => {
  const candidates = [
    value?.company_name,
    value?.company?.name,
    typeof value?.company === 'string' ? value.company : null,
    value?.customer_company,
    value?.client_company,
  ];
  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const normalized = candidate.trim();
    if (normalized) return normalized;
  }
  return null;
};
